import { chakra } from '@chakra-ui/react';

const SVGIcon = ({ ...props }) => (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M438.47 279.097C452.952 246.637 381.359 155.948 312.964 118.165C269.853 88.895 224.93 92.9162 215.832 105.768C195.865 133.972 281.948 157.871 339.518 185.759C327.143 191.152 315.481 200.83 308.623 213.207C287.16 189.697 240.052 169.451 184.777 185.759C147.528 196.749 116.571 222.658 104.606 261.791C101.699 260.495 98.4799 259.774 95.0934 259.774C82.1436 259.774 71.6456 270.308 71.6456 283.301C71.6456 296.295 82.1436 306.828 95.0934 306.828C97.4937 306.828 104.999 305.213 104.999 305.213L224.93 306.085C176.967 382.43 139.063 393.59 139.063 406.817C139.063 420.043 175.331 416.459 188.948 411.529C254.138 387.928 324.155 314.373 336.17 293.199C386.625 299.515 429.028 300.262 438.47 279.097Z"
      fill="url(#paint0_linear_1758_656)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M339.513 185.763C339.516 185.764 339.519 185.766 339.522 185.767C342.191 184.712 341.759 180.758 341.026 177.652C339.342 170.515 310.284 141.724 282.997 128.829C245.815 111.257 218.435 112.163 214.39 120.262C221.964 135.837 257.077 150.461 293.748 165.733C309.394 172.249 325.323 178.883 339.519 185.76C339.517 185.761 339.515 185.762 339.513 185.763Z"
      fill="url(#paint1_linear_1758_656)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M292.329 342.523C284.809 339.64 276.315 336.994 266.658 334.594C276.955 316.108 279.115 288.74 269.391 271.437C255.743 247.153 238.612 234.228 198.802 234.228C176.907 234.228 117.955 241.628 116.909 291.006C116.799 296.187 116.906 300.935 117.28 305.301L224.93 306.084C210.417 329.185 196.825 346.318 184.926 359.345C199.213 363.019 211.003 366.103 221.828 368.934C232.098 371.62 241.499 374.079 251.339 376.598C266.182 365.748 280.135 353.917 292.329 342.523Z"
      fill="url(#paint2_linear_1758_656)"
    />
    <path
      d="M103.169 300.228C107.567 337.737 128.813 352.437 172.227 356.788C215.641 361.138 240.544 358.22 273.698 361.246C301.389 363.774 326.113 377.932 335.285 373.04C343.539 368.636 338.921 352.728 327.876 342.521C313.558 329.291 293.742 320.093 258.875 316.828C265.824 297.739 263.877 270.973 253.085 256.411C237.481 235.355 208.68 225.836 172.227 229.995C134.143 234.34 97.6504 253.153 103.169 300.228Z"
      fill="url(#paint3_linear_1758_656)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1758_656"
        x1="180.439"
        y1="250.352"
        x2="435.479"
        y2="322.433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8697FF" />
        <stop offset="1" stopColor="#ABB7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1758_656"
        x1="392.428"
        y1="245.489"
        x2="207.876"
        y2="61.1077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8697FF" />
        <stop offset="1" stopColor="#5156D8" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1758_656"
        x1="297.446"
        y1="348.967"
        x2="120.465"
        y2="247.558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#465EED" />
        <stop offset="1" stopColor="#8697FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1758_656"
        x1="195.658"
        y1="248.443"
        x2="315.581"
        y2="400.306"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8898FF" />
        <stop offset="0.983895" stopColor="#6277F1" />
      </linearGradient>
    </defs>
  </svg>
);

const Rabby = chakra(SVGIcon);
export default Rabby;
